import image01 from "../images/team/01.jpg";
import image02 from "../images/team/02.jpg";
import image03 from "../images/team/03.jpg";
import image04 from "../images/team/04.jpg";
import image05 from "../images/team/05.jpg";
import image06 from "../images/team/06.jpg";
import image07 from "../images/team/07.jpg";
import image08 from "../images/team/08.jpg";
import image09 from "../images/team/09.jpg";
import image10 from "../images/team/10.jpg";
import image11 from "../images/team/11.jpg";
import image12 from "../images/team/12.jpg";
import image13 from "../images/team/13.jpg";
import image14 from "../images/team/14.jpg";
import image15 from "../images/team/15.jpg";
import image16 from "../images/team/16.jpg";

export const teamsData = [
  {
    id: "01",
    name: "Florence Otto Koeswara",
    major: "Business Administration",
    faculty: "FIA UI 2020",
    backgrounds: [
      "Employer Branding Intern at AwanTunai",
      "Community Intern at Jobstreet Indonesia",
      "Manager of Post College at UI Achievement Community",
    ],
    role: "Senior Advisor",
    image: image01,
  },
  {
    id: "02",
    name: "Putu Adrien P. Merada",
    major: "Law",
    faculty: "FH UI 2020",
    backgrounds: [
      "Head of Publication at Jakarta Model United Nation",
      "Legal Intern at Kejaksaan Republik Indonesia",
      "Vice Head of E-MUN at ALSA LC UI",
    ],
    role: "Senior Advisor",
    image: image02,
  },
  {
    id: "03",
    name: "Marsha Huwaidaa",
    major: "Dutch/Flemish Language and Literature",
    faculty: "FIB UI 2020",
    backgrounds: [
      "B2B Marketing and Communication at Bosch",
      "Market Research Analyst at Home Credit Indonesia",
      "External Affairs Associate at StudentsxCEOs International Summit",
    ],
    role: "Project Consultant",
    image: image03,
  },
  {
    id: "04",
    name: "Vemi Xafiera",
    major: "Architecture",
    faculty: "FT UI 2020",
    backgrounds: [
      "Vice Director of Finance at Enterprise Engineering Summit",
      "Marketing Representative at UI Talks",
      "Official Campus Ambassador of International MUN",
    ],
    role: "Project Consultant",
    image: image04,
  },
  {
    id: "05",
    name: "Nurhaliza Inayah",
    major: "Management",
    faculty: "FEB UI 2020",
    backgrounds: [
      "Research Analyst Intern at Skha",
      "Chief Strategy Officer at Management Student Society",
      "Non-Bank Financial Services Department intern at Otoritas Jasa Keuangan",
    ],
    role: "Project Consultant",
    image: image05,
  },
  {
    id: "06",
    name: "Salma Maysa",
    major: "International Relations",
    faculty: "FISIP UI 2020",
    backgrounds: [
      "Education Research Intern at Schoters",
      "Liaison Officer at UI International Conference on G20 Indonesia Presidency 2022",
      "Business Development Staff at FPCI Chapter Universitas Indonesia",
    ],
    role: "Project Consultant",
    image: image06,
  },
  {
    id: "07",
    name: "Alda Eunique",
    major: "Law",
    faculty: "FH UI 2020",
    backgrounds: [
      "Legal Intern at Budidjaja International Lawyers",
      "Legal Intern at Kementerian Hukum dan Hak Asasi Manusia Republik Indonesia",
      "Co-Convener of The 26th ALSA National English Competition",
    ],
    role: "Project Consultant",
    image: image07,
  },
  {
    id: "08",
    name: "Syafira Putri Septiadi",
    major: "Islamic Economics",
    faculty: "FEB UI 2021",
    backgrounds: [
      "Treasurer at The Music Gallery",
      "Staff of Public Relation at Kelompok Studi Pasar Modal FEB UI",
      "Secretary of Indonesia Capital Market Festival",
    ],
    role: "Director of Company Partnership",
    image: image08,
  },
  {
    id: "09",
    name: "Tsabita Moeldi Salsabila",
    major: "Public Administration",
    faculty: "FIA UI 2021",
    backgrounds: [
      "Manager of Regeneration and Succession at HIMANERA UI",
      "Project Officer of Himanera Muda FIA UI 2023",
    ],
    role: "Director of Company Partnership",
    image: image09,
  },
  {
    id: "10",
    name: "Adelia Hasna Nabilla",
    major: "Accounting",
    faculty: "FEB UI 2021",
    backgrounds: [
      "Founder & Executive Director of Meniti Kita Creative",
      "Marketing Intern at Bangbeli",
      "Director of Marketing at Initiatee UI",
    ],
    role: "Director of Community Relations",
    image: image10,
  },
  {
    id: "11",
    name: "Enzelika Rahel Sininta",
    major: "Public Health",
    faculty: "FKM UI 2021",
    backgrounds: ["Team Member of Strategic Business Growth at AIESEC UI"],
    role: "Director of Programme",
    image: image11,
  },
  {
    id: "12",
    name: "Arina Ahlam Halimi",
    major: "Psychology",
    faculty: "FPsi UI 2021",
    backgrounds: [
      "HR People Development at PT Rumah Konsul",
      "Human Resource Development Staff at Psikologi untuk Negeri",
      "Treasurer of Entrepreneur Week UI",
    ],
    role: "Director of Technicalities",
    image: image12,
  },
  {
    id: "13",
    name: "Febrina Jemimah T. Aritonang",
    major: "Management",
    faculty: "FEB UI 2021",
    backgrounds: [
      "Staff of Entrepreneurship and Leadership Department at BEM FEB UI",
      "Senior Manager of Marketing Insights Seminar and Training (MIST) FEB UI",
      "Associate of Competition at Management e[X]posed (M[X]) FEB UI",
      "Staff of Communication and General Affairs at Kompetisi Ekonomi (KOMPeK)",
    ],
    role: "Director of Marketing",
    image: image13,
  },
  {
    id: "14",
    name: "Tania Annisa",
    major: "Psychology",
    faculty: "FPsi UI 2021",
    backgrounds: [
      "External Vice Project Officer of Introduction to Psychology",
      "Public Relations Intern at KAMI Foundation",
      "Head of Public Relations at UI Sehat Mental",
    ],
    role: "Director of Design",
    image: image14,
  },
  {
    id: "15",
    name: "Joan Beth Ovadya Siahaan",
    major: "Economics",
    faculty: "FEB UI 2021",
    backgrounds: [
      "Director of Liaison Officer at ECONOMIX FEB UI",
      "Staff of Human Resource Development at KANOPI FEB UI",
      "Deputy Director of Sound System and Stage at The 13th Music Gallery",
    ],
    role: "Director of Finance",
    image: image15,
  },
  {
    id: "16",
    name: "Aulia Rohmah Isya",
    major: "Economics",
    faculty: "FEB UI 2021",
    backgrounds: [
      "Manager of Creative Marketing at Kelompok Studi Pasar Modal FEB UI",
      "Design Manager at Bisavest",
      "Project Staff at Klub Mode UI",
    ],
    role: "Director of Finance",
    image: image16,
  },
];
